import Vue from "vue";
import _ from "lodash";
import MQTT from "paho-mqtt";
import MqttTopic from "@/models/MqttTopic";

window.Paho = { MQTT };

// console.log(MQTT);

const EVENT_SOURCE = "mqtt-client";

export default Vue.component("mqtt-client", {
	EVENT_SOURCE,

	props: {
		clientId: {
			type: String,
			required: true
		},

		host: { type: String, required: true },
		port: { type: [String, Number], default: 9001 }, // MQTT via websockets
		protocol: { type: String, default: "wss://" }, // websockets + SSL/TLS
		suffix: { type: String, default: "/" },
		username: { type: String, default: null },
		password: { type: String, default: null },

		reconnect: { type: Boolean, default: false },
		connectTimeoutSecs: { type: Number, default: 30 },
		reconnectTimeoutMillis: { type: Number, default: 5000 },
		maxReconnectAttempts: { type: Number, default: 0 },

		useSSL: { type: Boolean, default: true },

		subscriptions: {
			type: [Array, Object],
			default: function() {
				return [{ topic: "#", qos: 0 }];
			}
		}
	},

	data() {
		return {
			reconnectAttempts: 0,
			client: null,
			isConnected: false,
			disconnecting: false
		};
	},
	watch: {
		isConnected(val, old) {
			if (val !== old) {
				if (val) console.info("MQTT Client has connected!");
				else console.info("MQTT Client has disconnected!");
			}
			this.$emit(EVENT_SOURCE + ":isConnected", {
				clientId: this.clientId,
				isConnected: val
			});
		},
		subscriptions(val, old) {
			this.resetSubscriptions(old);
		}
	},
	beforeMount() {
		// console.log("beforeMount() MQTT client", this, this.username);
		this.connect();
		this.$root.$refs.mqttClientComponent = this;
	},
	methods: {
		connect() {
			// console.log("MQTT Client Connect()");
			this.isConnected = false;
			var c = new MQTT.Client(
				this.host,
				parseInt(this.port),
				this.suffix,
				this.clientId
			);
			this.client = c;

			window._mqtt_client = this._client;
			var clientOptions = {
				timeout: this.connectTimeoutSecs,
				useSSL: this.useSSL,
				userName: this.username,
				password: this.password,
				onSuccess: this.onClientConnectSuccess,
				onFailure: this.onClientConnectFailed
			};

			this.client.onConnectionLost = this.onClientConnectionLost;
			this.client.onMessageArrived = this.onClientMessageArrived;

			this.$emit(EVENT_SOURCE + ":beforeConnect", this.client);
			this.client.connect(clientOptions);
			this.$emit(EVENT_SOURCE + ":afterConnect", this.client);
		},

		onClientConnectSuccess() {
			this.isConnected = true;
			this.resetSubscriptions();
			this.publishConnectMessage();
			this.$emit(EVENT_SOURCE + ":subscribed", this.client);
		},

		onClientMessageArrived(message) {
			// console.log("MQTT Client Message Arrived", message);
			this.$emit(EVENT_SOURCE + ":messageArrived", message);
		},

		onClientConnectFailed(reason) {
			console.error("MQTT Client connection failed.");
			this.isConnected = false;
			this.reconnectAttempts = 0;
			this.$emit(EVENT_SOURCE + ":connectFailed", {
				client: this.client,
				reason
			});
			this.checkReconnect();
		},

		onClientConnectionLost(reason) {
			console.error("MQTT Client connection lost.");
			this.isConnected = false;
			this.reconnectAttempts = 0;
			this.$emit(EVENT_SOURCE + ":connectionLost", {
				client: this.client,
				reason
			});
			this.checkReconnect();
		},

		checkReconnect() {
			if (this.isConnected) return;
			if (!this.reconnect) return;

			this.reconnectAttempts++;

			console.error(
				`Attempt ${this.reconnectAttempts} to reconnect to MQTT Client.`
			);

			if (
				this.maxReconnectAttempts > 0 &&
				this.reconnectAttempts >= this.maxReconnectAttempts
			)
				return;

			setTimeout(() => {
				this.connect();
			}, this.reconnectTimeoutMillis);
		},

		disconnect() {
			this.isConnected = false;
			this.client.disconnect();
			this.client = null;
		},

		resetSubscriptions(oldSubscriptions) {
			if (_.isEmpty(oldSubscriptions)) oldSubscriptions = [];
			_.forEach(oldSubscriptions, s =>
				_.isEmpty(s) ? null : this.unsubscribe(s)
			);
			_.forEach(this.subscriptions, s => {
				if (_.isEmpty(s)) return;
				this.subscribe(s);
			});
		},

		unsubscribe(subscription, opts) {
			if (!this.isConnected) return;

			if (opts === void 0) opts = {};

			if (typeof subscription === "string")
				return this.client.unsubscribe(subscription, opts);

			const s = Object.assign({}, subscription);
			const topic = s.topic;
			delete s.topic;
			delete s.qos; // The client is going to validate this object, and qos isn't one of the options it considers valid.
			const options = s;
			return this.client.unsubscribe(topic, Object.assign({}, opts, options));
		},

		subscribe(subscription, opts) {
			if (!this.isConnected) return;

			if (opts === void 0) opts = { qos: 0 };

			if (typeof subscription === "string")
				return this.client.subscribe(subscription, opts);

			const s = Object.assign({}, subscription);
			const topic = s.topic;
			delete s.topic;
			const options = s;
			return this.client.subscribe(topic, Object.assign({}, opts, options));
		},

		publishConnectMessage() {
			this.publish(
				[
					"v1",
					"clients",
					"tfm-DeviceManager_" + this.clientId,
					"connection",
					"connectionStatusChange",
					"notifiction"
				],
				{
					connected: true
				}
			);
		},

		publish(topic, payload, qos) {
			if (qos === void 0) qos = 0;
			if (Array.isArray(topic)) topic = topic.join("/");
			// this.client.send(topic, JSON.stringify(payload), qos, false);
		},

		parseTopic(topic) {
			return new MqttTopic(topic);
		}
	},
	render(h) {
		return h("div", { class: "mqtt-client" }, []);
	}
});
